var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0.54541L0 11.4545L15 11.4545L7.5 0.54541Z",
    className: "baseColor2Fill"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_2898",
    x1: 15,
    y1: 9.38418,
    x2: 0,
    y2: 9.38418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0004D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#772583"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDownArrow);
export default __webpack_public_path__ + "static/media/triangle-down-arrow.b1ee6d25d41993766ba9900b4dd7b18c.svg";
export { ForwardRef as ReactComponent };